export default __webpack_public_path__ + "static/media/menu_link_settings_selected.c92575ff.svg";